export type PrimitivesType = string | number | boolean | undefined | null;

export type TObject = Record<
  string,
  PrimitivesType | Array<PrimitivesType> | object
>;

export * from "./response";
export * from "./api";
export * from "./dto";
export * from "./others";
